import React from 'react';

class CheckoutSubheaderEntry extends React.Component {
    render() {
        return (
            <div className={"shrink-0 inline-block mr-4"
            + (this.props.active ? " opacity-100" : " opacity-50")
            + (this.props.hideOnMobile ? " hidden sm:block" : "")}>

                <div className="opacity-100 flex items-center">
                    <div className="bg-white text-primary w-6 h-6 mr-2 flex items-center justify-center">{this.props.nr}</div>
                    <div className="whitespace-nowrap">{this.props.text}</div>
                </div>
            </div>
        )
    }
}

export default CheckoutSubheaderEntry;